import { IValidationRule } from "@/types"

const specialDepreciationValidationRules: { [s: string]: IValidationRule } = {
    amount: {
        required: true,
        type: "decimal",
        nonZero: true,
    },
    comment: {
        required: true,
    },
}

export default specialDepreciationValidationRules
